import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { Icon_Image } from 'src/app/Constants/Constants-Global/Images-Icon';
import { Icon_Images } from 'src/app/Interfaces/Interfaces-Global/Icon_Images.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Data_RecycleBin_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Data_RecycleBin.interface';
import { Data_Check, Filter_Check_FIN, Filter_Check_FIN_Recicle } from 'src/app/Interfaces/Libraries/Library-FIN-int/Filter_Check_FIN.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-recycle-bin-file-fin',
    templateUrl: './recycle-bin-file-fin.component.html',
    styleUrls: ['./recycle-bin-file-fin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/RecycleBin.scss'],
    standalone: false
})
export class RecycleBinFileFINComponent implements OnInit {


  //+================== VARIABLES FOR HEADERS RB ==================+\\
  public HeadersRB: Headers_CCP[] = [
    { ID: 1, Name: 'Icono', Position: 1, Visible: true, Key_Header: 'ICONF' },
    { ID: 1, Name: 'Nombre', Position: 1, Visible: true, Key_Header: 'NAMFI' },
    { ID: 1, Name: 'Ubicación original', Position: 1, Visible: true, Key_Header: 'ROUTE' },
    { ID: 1, Name: 'Usuario que eliminó', Position: 1, Visible: true, Key_Header: 'USEDE' },
    { ID: 1, Name: 'Fecha de eliminación', Position: 1, Visible: true, Key_Header: 'DATED' },
    { ID: 1, Name: '', Position: 1, Visible: true, Key_Header: 'DELET' },
  ]


  //+================== VARIABLES FOR SEARCH ==================+\\
  public Filter_RecycleBin: string = '';


  //+================== VARIABLE FOR ALL RECYCLE BIN FIN ==================+\\
  public List_RecycleBin: Data_RecycleBin_FIN[] = [];
  public SelectedList_RecycleBin: Data_RecycleBin_FIN[] = [];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_FIN_Recicle = {
    Extension: [],
    Status: [],
    Revision_No: [],
    Approver1_Name: [],
    Approver2_Name: [],
    Approver3_Name: [],
    Approver4_Name: [],
    Contributor_Name: [],
    Name_User_Deleted: []
  };

  //+================== VARIABLES FOR REGULAR EXPRESION ==================+\\
  private Expression1: RegExp = /[/]+[0-9]+§/

  //+================== VARIABLES FOR ICONS IMAGE ==================+\\
  public Icons_Image: Icon_Images[] = Icon_Image;

  //+================== VARIABLE FOR ALL VERSION FIN ==================+\\
  public LoadPage: boolean = false;
  public CurrentLibrarySlug: string = 'fin';


  //-========================= SERVICES =========================-\\
  private Service_FIN = inject(LibraryFINService);
  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.CurrentLibrarySlug = (this.route.snapshot.paramMap.get('libSlug') || 'fin').toLowerCase();
    this.Load_Component_RB();
  }



  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_Component_RB(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {
      this.List_RecycleBin = [];

      const ResRecycleBin: Response_FIN = await firstValueFrom(this.Service_FIN.Get_All_RecycleBin_FIN(this.CurrentLibrarySlug));

      if (ResRecycleBin.success) {
        this.List_RecycleBin = ResRecycleBin.operation;

      }

      Loader.classList.remove('active');
      this.LoadPage = true;

      this.Generate_Filters();


    } catch (e) {

      Swal.fire({
        title: 'Error',
        text: '¡Error al cargar la papelera de reciclaje, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      Loader.classList.remove('active');
      this.LoadPage = true;
    }

  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\





  //&===================== FUNCTION FOR RESTORE OR DELETED FILE OR DIRECTORY =====================&\\

  //-================== FUNCTION TO RESTORE A FILE OR DIRECTORY ==================-\\

  // ============== FUNCTION FOR VERIFY IF FILE SELECT IS FILE OR DIRECTORY ==============\\

  public Restore_File_Or_Directory(FileRecycle: Data_RecycleBin_FIN): void {

    FileRecycle.Directory ? this.Restore_Directory_FIN(FileRecycle) : (this.Restore_File_FIN(FileRecycle));

  }

  // ============== FUNCTION FOR RESTORE FILE FIN ==============\\
  private Restore_File_FIN(FileRecycle: Data_RecycleBin_FIN): void {

    Swal.fire({
      title: '¿Está seguro de restaurar el Proceso?',
      text: "¡No podrá recuperar el Proceso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, restaurar!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Marque la casilla para restaurar el Proceso!`,
          input: 'checkbox',
          inputPlaceholder: 'Restaurar Proceso',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async (result2: any) => {

          if (result.isConfirmed) {

            if (result2.value === 1) {

              try {

                const ResMoveRBin: Response_FIN = await firstValueFrom(this.Service_FIN.Restore_Process_FIN({ ID_FIN: FileRecycle.ID }, this.CurrentLibrarySlug));

                if (ResMoveRBin.success) {
                  Swal.fire({
                    icon: 'success',
                    title: `Proceso restaurado`,
                    text: `¡Se restauró correctamente el proceso!`,
                    confirmButtonColor: this.ColorConfirm
                  });

                  this.Load_Component_RB();
                }


              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: `Error al restaurar el proceso`,
                  text: `¡No se restauró el proceso, notifica a tu supervisor!`,
                  confirmButtonColor: this.ColorConfirm
                });

                this.Load_Component_RB();


              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin confirmar',
                text: '¡Marque la casilla para restaurar el Proceso!',
                confirmButtonColor: this.ColorConfirm
              });

            }

          }


        }))
      }
    })

  }

  // ============== FUNCTION FOR RESTORE DIRECTORY ==============\\
  private Restore_Directory_FIN(FileRecycle: Data_RecycleBin_FIN): void {

    const NameRestore: string = (FileRecycle.Name).trim();

    Swal.fire({
      title: '¿Está seguro de restaurar el directorio?',
      text: "¡No podrá revertir cambios!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡Sí, restaurar!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Para restaurar el directorio escriba ${NameRestore} !`,
          input: 'text',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async result2 => {

          if (result2.isConfirmed) {

            const ValueInput: string = result2.value;

            if (ValueInput.toLowerCase() === NameRestore.toLowerCase()) {

              try {

                const ResDeleteDir: Response_FIN = await firstValueFrom(this.Service_FIN.Restore_Directory_FIN({ ID_Folder: FileRecycle.ID }, this.CurrentLibrarySlug));

                if (ResDeleteDir.success) {
                  Swal.fire({
                    icon: 'success',
                    title: `Directorio restaurado`,
                    text: `¡Se restauró correctamente el directorio!`,
                    confirmButtonColor: this.ColorConfirm
                  });
                  this.Load_Component_RB();
                }


              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: `Error al restaurar el directorio`,
                  text: `¡No se restauró el directorio, notifica a tu supervisor!`,
                  confirmButtonColor: this.ColorConfirm
                });
                this.Load_Component_RB();
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin coincidencia',
                text: '¡Escriba correctamente el nombre del directorio para restaurarlo!',
                confirmButtonColor: this.ColorConfirm
              })
            }
          }
        }))
      }
    })
  }


  //-================== FUNCTION TO DELETE A FILE OR DIRECTORY ==================-\\

  // ============== FUNCTION FOR VERIFY IF FILE SELECT IS FILE OR DIRECTORY ==============\\
  public Delete_File_or_Directory(FileRecycle: Data_RecycleBin_FIN): void {

    FileRecycle.Directory ? (this.Delete_Directory_Permanently_FIN(FileRecycle)) : (this.Delete_File_Permanently_FIN(FileRecycle));

  }

  // ============== FUNCTION FOR DELETE FILE FIN ==============\\
  private Delete_File_Permanently_FIN(FileRecycle: Data_RecycleBin_FIN): void {

    Swal.fire({
      title: '¿Está seguro de eliminar el Proceso permanentemente?',
      text: "¡No podrá recuperar el Proceso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar permanentemente!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Marque la casilla para eliminar permanentemente el Proceso!`,
          input: 'checkbox',
          inputPlaceholder: 'Eliminar Proceso permanentemente',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async (result2: any) => {

          if (result2.isConfirmed) {

            if (result2.value===1) {

              try {

                const ResMoveRBin: Response_FIN = await firstValueFrom(this.Service_FIN.Delete_Permanently_File_FIN({ ID_FIN: FileRecycle.ID }, this.CurrentLibrarySlug));

                if (ResMoveRBin.success) {
                  Swal.fire({
                    icon: 'success',
                    title: `Proceso eliminado permanentemente`,
                    text: `¡Se eliminó correctamente el proceso!`,
                    confirmButtonColor: this.ColorConfirm
                  });

                  this.Load_Component_RB();
                }


              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: `Error al eliminar el proceso`,
                  text: `¡No se eliminó el proceso, notifica a tu supervisor!`,
                  confirmButtonColor: this.ColorConfirm
                });

                this.Load_Component_RB();


              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin confirmar',
                text: '¡Marque la casilla para eliminar el Proceso!',
                confirmButtonColor: this.ColorConfirm
              });

            }

          }


        }))
      }
    })

  }

  // ============== FUNCTION FOR DELETE DIRECTORY ==============\\
  private Delete_Directory_Permanently_FIN(FileRecycle: Data_RecycleBin_FIN): void {

    const NameDelete: string = (FileRecycle.Name).trim();

    Swal.fire({
      title: '¿Está seguro de eliminar el directorio permanentemente?',
      text: "¡No podrá revertir cambios!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar permanentemente!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Para eliminar permanentemente la carpeta escriba ${NameDelete} !`,
          input: 'text',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async result2 => {

          if (result2.isConfirmed) {

            const ValueInput: string = result2.value;

            if (ValueInput.toLowerCase() === NameDelete.toLowerCase()) {

              try {

                const ResDeleteDir: Response_FIN = await firstValueFrom(this.Service_FIN.Delete_Permanently_Dir_FIN({ ID_Folder: FileRecycle.ID }, this.CurrentLibrarySlug));

                if (ResDeleteDir.success) {
                  Swal.fire({
                    icon: 'success',
                    title: `Directorio eliminado permanentemente`,
                    text: `¡Se eliminó correctamente el directorio!`,
                    confirmButtonColor: this.ColorConfirm
                  });
                  this.Load_Component_RB();
                }


              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: `Error al eliminar el directorio`,
                  text: `¡No se eliminó el directorio, notifica a tu supervisor!`,
                  confirmButtonColor: this.ColorConfirm
                });
                this.Load_Component_RB();
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin coincidencia',
                text: '¡Escriba correctamente el nombre del directorio para eliminarlo!',
                confirmButtonColor: this.ColorConfirm
              })
            }
          }
        }))
      }
    })
  }

  //&===================== END FUNCTION FOR RESTORE OR DELETED FILE OR DIRECTORY =====================&\\





  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTION FOR FILTERS ==================-\\
  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Status: [],
      Revision_No: [],
      Approver1_Name: [],
      Approver2_Name: [],
      Approver3_Name: [],
      Approver4_Name: [],
      Contributor_Name: [],
      Name_User_Deleted: []
    };

    for (const FIN of this.List_RecycleBin as any) {

      FIN.Date_Deleted = moment(FIN.Date_Deleted).utc().toDate();

      FIN.F_Extension = { Value: FIN.Extension } as Data_Check;

      if (!this.Filter_Global_Check.Extension.some(item => item.Value === FIN.Extension) && FIN.Extension !== null) {
        this.Filter_Global_Check.Extension.push({ Value: FIN.Extension })
      }

      if (!this.Filter_Global_Check.Name_User_Deleted.includes(FIN.Name_User) && FIN.Name_User !== null) {
        this.Filter_Global_Check.Name_User_Deleted.push(FIN.Name_User);
      }

    }


  }

  //-============== FUNCTION FOR FORMAT DATE DELETED ==============-\\
  public Get_Date_Deleted(Date_Deleted: Date | null): string {
    return moment(Date_Deleted).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-================ FUNCTION FOR CLEAN ROUTE ================-\\
  public Clean_Route(Route: string): string {

    const Route_Add: string = '/RAIZ/' + Route;

    const Route_Clean: string = Route_Add.split(this.Expression1).join('/');

    return Route_Clean.replace('/', '');
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\


}
